import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { fmtErr } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-14">
      <div className="bg-white rounded-2xl border border-[#BFE8E9] p-8 shadow-sm animate-rise">
        <h1 className="font-display font-bold text-xl mb-2">Choose a new password</h1>
        {!token ? (
          <p className="text-sm text-red-600" data-testid="reset-no-token">This reset link is missing its token. Please request a new one.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>New password</Label>
              <Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
            <Button type="submit" className="w-full bg-[#0E7C84] hover:bg-[#093F46]" disabled={loading} data-testid="reset-submit-btn">
              <KeyRound className="w-4 h-4 mr-2" /> {loading ? "Updating…" : "Update password"}
            </Button>
          </form>
        )}
        <p className="mt-4 text-sm text-center">
          <Link to="/login" className="text-[#0E7C84] hover:underline" data-testid="reset-back-login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
